<app-viewer>
  <router-outlet></router-outlet>
</app-viewer>

<app-progress-spinner
  [displayProgressSpinner]="displayProgressSpinner"
  mode="indeterminate"
></app-progress-spinner>
